export default __webpack_public_path__ + "static/media/button-play-now.4fcff411.png";